export default{
    refundDetail:{

        stepState:{
            step1:'提交申请',
            step2:'等待审核',
            step3:'审核不通过',
            step4:'已取消',
            step5:'完成',
        },
        fwdjd:{
            msg1:'服务单进度',
            msg2:'服务单号：',
            msg3:'申请时间：',
            msg4:'服务状态：',
            msg5:'取消服务单',
            msg6:'联系商家',
            msg7:'操作人：',
            msg8:'操作时间：',
        },
        fwdxx:{
            fwd1:'服务单信息',
            fwd2:'订单信息',
            fwd3:'订单编号：',
            fwd4:'支付方式：',
            fwd5:'订单金额：',
            fwd6:'支付金额：',
            fwd7:'配送方式：',
            fwd8:'卖家配送',
            fwd9:'买家自提',
            fwd10:'支付类型：',
        },
        peisong:{
            psInfo1:'配送信息',
            psInfo2:'收货人：',
            psInfo3:'手机号：',
            psInfo4:'地址：',
            psInfo5:'自提点名称：',
            psInfo6:'自提地址：',
            psInfo7:'自提联系人：',
            psInfo8:'联系方式：',
        },
        tuikuan:{
            tkInfo1:'退款信息',
            tkInfo2:'退款方式：',
            tkInfo3:'原支付方式返回',
            tkInfo4:'货物状态：',
            tkInfo5:'退款原因：',
            tkInfo6:'申退总金额：',
            tkInfo7:'实退总金额：',
            tkInfo8:'退款状态：',
            tkInfo9:'备注信息：',
        },
        qingdan:{
            qdInfo1:'清单信息',
            qdInfo2:'商品',
            qdInfo3:'规格：',
            qdInfo4:'数量',
            qdInfo5:'单价',
            qdInfo6:'小计',
            qdInfo7:'商品数量：',
            qdInfo8:'商品申退金额：',
            qdInfo9:'运费申退金额：',
            qdInfo10:'申退总金额：',

        },
        confirmState:{
            confirm1:'提示',
            confirm2:'确定',
            confirm3:'取消',
            confirm4:'已取消',
            confirm5:'是否取消服务单?',
        }
    }
    
}